import { Field } from 'formik';
import './fields.css';
import ErrorShow from './ErrorShow';
import React from 'react';
import { FormLabel } from './FormLable/FormLabel';
import { convertPersianNumbersToEnglish } from './utils';

export const PhoneInputField = ({
  name,
  placeholder,
  errors = {},
  touched = {},
  className,
  countryCodeClassName,
  phoneFieldProps = {},
  label,
  twoItemInOneRow,
  hasLable = true,
  icon, // آیکون جدید
  iconPosition = 'left', // موقعیت آیکون: 'left' یا 'right'
  onIconClick, // تابع کلیک روی آیکون
}) => {
  const hasPhoneError = errors[name] && touched[name];
  const phoneFieldClassName = `form-control ${className} ${hasPhoneError ? 'is-invalid' : ''}`;

  const handlePhoneChange = (e, field, form) => {
    const value = e.target.value;
    const convertedValue = convertPersianNumbersToEnglish(value);
    const numericValue = convertedValue.replace(/[^\d]/g, '');

    form.setFieldValue(field.name, numericValue);
  };

  return (
    <div className={`form-group ${twoItemInOneRow ? 'two-in-one-row' : ''}`} dir='rtl'>
      {hasLable && <FormLabel name={name} label={label} />}

      <div className='input-with-icon-container' style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {icon && iconPosition === 'right' && (
          <div
            className='input-icon input-icon-right'
            onClick={onIconClick}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: onIconClick ? 'pointer' : 'default',
              zIndex: 1,
              color: '#6c757d',
            }}
          >
            {icon}
          </div>
        )}

        <Field name={name}>
          {({ field, form }) => (
            <input
              dir='rtl'
              type='tel'
              inputMode='numeric'
              name={field.name}
              value={field.value || ''}
              onChange={(e) => handlePhoneChange(e, field, form)}
              onBlur={field.onBlur}
              className={phoneFieldClassName}
              placeholder={placeholder}
              style={{
                flex: 1,
                paddingRight: icon && iconPosition === 'right' ? '35px' : '10px',
                paddingLeft: icon && iconPosition === 'left' ? '35px' : '10px',
              }}
              {...phoneFieldProps}
            />
          )}
        </Field>

        {icon && iconPosition === 'left' && (
          <div
            // className='input-icon input-icon-left'
            onClick={onIconClick}
            style={{
              position: 'absolute',
              left: '10px',
              top: '45%',
              transform: 'translateY(-50%)',
              cursor: onIconClick ? 'pointer' : 'default',
              zIndex: 1,
              color: '#6c757d',
              backgroundColor: 'white',
            }}
          >
            {icon}
          </div>
        )}
      </div>

      <ErrorShow errors={errors} touched={touched} name={name} />
    </div>
  );
};
